import React, { Component } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import MerchantDetail from './MerchantDetail/MerchantDetail';
import StudentProfile from './StudentProfile/StudentProfile';
import RewardDetail from './RewardDetail/RewardDetail';
import FourOhFour from './FourOhFour/FourOhFour';
// import UserProfile from './UserProfile/UserProfile'


class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pathname: props.pathname,
            hash: ""
        };
    }

    render() {
        return(
        <Router>
        <div>
          <Route exact path="/" component={StudentProfile} />      
          <Route path="/merchant/:id" component={MerchantDetail} />  
          <Route path="/reward/:id" component={RewardDetail}/>          
        </div>
      </Router>
        )    
    }

  }


export default App;



// WEBPACK FOOTER //
// ./src/components/App.js